let language = {
    DETAIL_SNAPSHOP_TITLE: "Installation",
    DETAIL_SNAPSHOP_DESCRIPTION_1: "If you have no e-shop yet, create a SnapShop with ",
    DETAIL_SNAPSHOP_DESCRIPTION_2: " to start selling our custom print-on-demand products. It is FREE of charge and can be setup within an hour. If you have any problem during the setup, contact us at",
    DETAIL_SNAPSHOP_NAME: "snap shop",
    DETAIL_SNAPSHOP_NAME_GROUP: "SnapShop",
}

export { language }